module.exports = __webpack_public_path__ + "img/25_litre@3x.28c0b00b.png";